export default {"src":"/_next/static/media/mastercard-light-noborder.38efa93e.svg","height":24,"width":36};